import React, { MutableRefObject } from "react";
import Checkbox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import Form, { RuleObject } from "antd/lib/form";
import { SurveyInput } from "pages/symptoms/surveyForms/surveyInput";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface ProcedureToRemoveKidneyStoneSectionProps {
  readonly currentPage: number;
  setOtherWhenWasKidneyStoneRemovedTempInput(input: string): void;
  readonly otherWhenWasKidneyStoneRemovedTempInput: string;
  readonly otherWhenWasKidneyStoneRemovedTempInputRef: MutableRefObject<string>;
  setShowSubmit(show: boolean): void;
}

export const ProcedureToRemoveKidneyStoneSection: React.FC<
  ProcedureToRemoveKidneyStoneSectionProps
> = ({
  currentPage,
  otherWhenWasKidneyStoneRemovedTempInputRef,
  otherWhenWasKidneyStoneRemovedTempInput,
  setOtherWhenWasKidneyStoneRemovedTempInput,
  setShowSubmit
}) => {
  const validateWhenWasProcedurePerformed = (
    rules: RuleObject,
    value: string,
    callback: (error?: string) => void
  ) => {
    if (
      otherWhenWasKidneyStoneRemovedTempInputRef.current === "" &&
      localStorage.getItem("whenWasProcedurePerformed")?.includes("Other")
    ) {
      callback("Please enter value for 'Other' field.");
    } else {
      callback();
    }
  };

  return (
    <>
      {currentPage === 12 && (
        <SurveyQuestionCard
          sectionTag="PROCEDURES TO REMOVE KIDNEY STONE"
          title="Have you ever had a procedure to remove your stone?"
          required
        >
          <FormItemStyle
            name="Have you ever had a procedure to remove your stone"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveHadProcedureToRemoveStone")}
              onChange={e => {
                if (e.target.value === "No") {
                  setShowSubmit(true);
                } else {
                  setShowSubmit(false);
                }
                localStorage.setItem(
                  "haveHadProcedureToRemoveStone",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="Yes">Yes</AnswerOption>
                <AnswerOption value="No">No</AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 13 && (
        <SurveyQuestionCard
          sectionTag="Kidney Stone Symptoms"
          title="When was this procedure performed?"
        >
          <FormItemStyle
            name="When was procedure performed"
            label=""
            initialValue={""}
            rules={[
              {
                validator: validateWhenWasProcedurePerformed,
                validateTrigger: "submit"
              }
            ]}
          >
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={e =>
                localStorage.setItem("whenWasProcedurePerformed", e.toString())
              }
              value={sessionStorage
                .getItem("whenWasProcedurePerformed")
                ?.split(/,/)}
            >
              <AnswerList>
                <AnswerOption value="In the last 2 weeks" isCheckbox>
                  In the last 2 weeks
                </AnswerOption>
                <AnswerOption value="In the last 3 months" isCheckbox>
                  In the last 3 months
                </AnswerOption>
                <AnswerOption value="In the last 3 - 6 months" isCheckbox>
                  In the last 3 - 6 months
                </AnswerOption>
                <AnswerOption value="In the last 6 - 12 months" isCheckbox>
                  In the last 6 - 12 months
                </AnswerOption>
                <AnswerOption value="More than 1 year ago" isCheckbox>
                  More than 1 year ago
                </AnswerOption>
                <AnswerOption value="Other" isCheckbox>
                  <div style={{ width: "100%" }}>
                    <span>Other</span>
                    <SurveyInput
                      value={
                        otherWhenWasKidneyStoneRemovedTempInput ||
                        otherWhenWasKidneyStoneRemovedTempInputRef.current
                      }
                      placeholder="Please specify"
                      onChange={e => {
                        setOtherWhenWasKidneyStoneRemovedTempInput(
                          e.target.value
                        );
                        otherWhenWasKidneyStoneRemovedTempInputRef.current =
                          e.target.value;
                      }}
                      style={{ marginTop: "8px", width: "100%" }}
                    />
                  </div>
                </AnswerOption>
              </AnswerList>
            </Checkbox.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
